module.exports = __webpack_public_path__ + "static/media/subtitle-icon-light.0bfc17e2.svg";